if (!customElements.get("accordion-panel")) {
    class AccordionPanel extends Element {
        constructor() {
            super();

            this.addEventListener("toggle", this.onToggle.bind(this), true);
        }

        onToggle(event) {
            const details = event.target;

            if (details.tagName !== "DETAILS" || !details.open) return;

            const trackId = details.querySelector(":scope > summary")?.dataset.trackId;

            if (!trackId) return;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: "click", click_type: trackId});
        }
    }

    customElements.define("accordion-panel", AccordionPanel);
}

if (!customElements.get("accordion-container")) {
    let accordionGroupCount = 0;

    class AccordionContainer extends Element {
        constructor() {
            super();

            this.groupName = `accordion-container-${++accordionGroupCount}`;
        }

        mounted() {
            super.mounted();

            this.querySelectorAll(":scope > accordion-panel > details").forEach((details) => {
                details.setAttribute("name", this.groupName);
            });
        }
    }

    customElements.define("accordion-container", AccordionContainer);
}
